module.exports = __webpack_public_path__ + "static/xvz60Z-9a72014bac787c1ad71d894e06c36105.gif";